'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require('materialize-css');
require('jquery-lazy');
require('slick-carousel');
require('sweetalert');
require('./contact');
var contLogin,campo,emailRegex;

$(function($) {
    $("img.lazy").Lazy({
        chainable: false,
        threshold: 500,
        visibleOnly: false,
    });
});

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.sidenav').sidenav({
        edge: 'left'
    });
    $(".dropdown-trigger").dropdown({
        hover: true
    });
    $('.modal').modal();
    $('#loader').hide();
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$('.clickBrand').click(function () {
    $('html, body').animate({
        scrollTop: $('#brand').offset().top - 100
    }, 1000);
});

$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
});

$('.clickServices').click(function () {
    $('html, body').animate({
        scrollTop: $('#services').offset().top - 100
    }, 1000);
});

$('.clickProducts').click(function () {
    $('html, body').animate({
        scrollTop: $('#products').offset().top - 100
    }, 1000);
});

$('.clickContact').click(function () {
    $('html, body').animate({
        scrollTop: $('#contact').offset().top - 100
    }, 1000);
});


$(document).ready(function () {
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: 'easeOutElastic',
        fade: true,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        customPaging : function(slider, i) {
            return '<a><img src="'+https+'img/banner/dots.svg"/><img src="'+https+'img/banner/dot-active.svg" /</a>';
        },
    });

    $('#sliderBanner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".sectionBanner img").css('transition','transform 0s');
        $(".sectionBanner img").css('transform','scale(1.1)');
    });
    $('#sliderBanner').on('afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function () {
            $(".sectionBanner img").css('transition','transform 4s');
            $(".sectionBanner img").css('transform','scale(1)');
        },100);
    });

    $('#sliderBrands').slick({
        dots: false,
        infinite: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#sliderServices').slick({
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        adaptiveHeight: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#sliderProducts').slick({
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        vertical: false,
        verticalSwiping: false,
        prevArrow: $('.productsSlider .prev'),
        nextArrow: $('.productsSlider .next'),
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                }
            }
        ]
    });

    $('#sliderBrandProducts').slick({
        dots: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    setTimeout(function () {
        var access_token = location.hash.split('=')[1];
        var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
        $.getJSON(URL_API_INSTAGRAM,function(data) {
            var i = 1;
            $('.instragramImages').html("");
            $.each(data.data, function (item, value) {
                if (i <= 8) {
                    $('.instragramImages').append('' +
                        '<div class="col s6 m3 l3 col-instagram">' +
                        '<a target="_blank" href="' + data.data[item].link + '">' +
                        '   <div class="containerInstagram">' +
                        '       <div class="img">'+
                        '           <img class="lazy" src="' + value.images.low_resolution.url + '" alt="">' +
                        '       </div>'+
                        '   </div>' +
                        '</a>' +
                        '</div>');
                }
                i++;
            });
        });
    },100);

});

$(window).scroll(function() {
    if($(window).width() < 600) {
        if ($(document).scrollTop() > 80) {
            $('#wpFloat').css('display','block');
        }else{
            if($(document).scrollTop() >=0 && $(document).scrollTop() <=75){
                $('#wpFloat').css('display','none');
            }
        }
    }
});

$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background', '#ffffff', '!important');
            $('.header a').css('color', '#10365C', '!important');
            $('.header .boton').css('color', '#171717', '!important');
            $('.header span').css('color', '#10365C', '!important');
            $('.header .brand-logo .desktop').attr('src', https + 'img/logo/distriequipo_color.svg');
            //$('.header').css('height', '85px', '!important');
            //$('.header').css('line-height', '85px', '!important');
            //$('.header .brand-logo .desktop').css('margin-top', '2%', '!important');
            $('.header .line').css('visibility', 'hidden', '!important');
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('background', 'transparent', '!important');
                $('.header a').css('color', '#ffffff', '!important');
                $('.header .boton').css('color', '#171717', '!important');
                $('.header span').css('color', '#ffffff', '!important');
                $('.header .brand-logo .desktop').attr('src', https + '/img/logo/distriequipo.svg');
                //$('.header').css('height', '100px', '!important');
                //$('.header').css('line-height', '100px', '!important');
                //$('.header .brand-logo .desktop').css('margin-top', '6%', '!important');
                $('.header .line').css('visibility', 'inherit', '!important');
            }
        }
    }
});

/*
$('.cardBox').click(function () {
    if($(this).attr('active') == 'no'){
        $('#card'+this.id).css('transform','rotateY(180deg)','important');
        $(this).attr('active','si');
    }else{
        $(this).attr('active','no');
        $('#card'+this.id).css('transform','rotateY(0deg)','important');
    }
});
*/

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

/*
setTimeout(function () {
    if(categoryIdGet >= 1){
        $.ajax({
            url: https + "getCategoriesProducts",
            method: "POST",
            data: {id:categoryIdGet,action:'getCategoriesProducts'},
            beforeSend: function() {
                $('#viewInfoProducts').hide();
                $('#loader').show();
            },
            complete: function(){
                setTimeout(function () {
                    $('#loader').hide();
                    $('#viewInfoProducts').show();
                },1000);
            },
            success: function (data) {
                $('#viewInfoProducts').html('');
                $('#viewInfoProducts').html(data);

            }
        });
    }
},500);
*/

/*
$('.sectionProducts .sliderProducts .element').click(function () {
    $('.sectionProducts .sliderProducts .element').removeClass('active');
    $(this).addClass('active');
    $.ajax({
        url: https + "getCategoriesProducts",
        method: "POST",
        data: {id:this.id,action:'getCategoriesProducts'},
        beforeSend: function() {
            $('#viewInfoProducts').hide();
            $('#loader').show();
        },
        complete: function(){
            setTimeout(function () {
                $('#loader').hide();
                $('#viewInfoProducts').show();
            },500);
        },
        success: function (data) {
            $('#viewInfoProducts').html('');
            $('#viewInfoProducts').html(data);
            $('html, body').animate({
                scrollTop: $('#viewInfoProducts').offset().top - 100
            }, 500);
        }
    });
});
*/